/*
 * File: d:\projects\AutoFiFront\src\Content\Login\Login.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday January 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday January 13th 2023 2:10:45 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import React from "react";
import styles from "Content/Login/Login.module.css";
import translator from "MultiLanguage/TranslationWrapper";
import { useTheme } from "styled-components";
import { useLocation } from 'react-router-dom';
import Form from "Content/Login/Form/Form";
import { ThemeType } from "Config/Theme/Theme.type";

function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Login() {
    const theme = useTheme() as ThemeType;
    const query = useQuery();

    return(
        <React.Fragment>
            <div className={`${styles.loginForm}`}>
                {/* <img className={styles.logo + " margined"} src={theme.logos.logo_horizontal} alt={translator.decode("logo.alt-description") as unknown as string} /> */}
                <p className="font-weight-700 small-font-2">{translator.decode("login.title") as unknown as string}</p>
                {/* <img id={styles.france} className={styles.logo + "margined"} src={theme.images.france} alt={translator.decode("login.image.france.alt-description")} /> */}
                <Form returnUrl={query.get("return_url")} />
            </div>
        </React.Fragment>
    );
}

export default Login;
